import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, mergeMap, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { User } from '../core/users/users.model';
import { UserActionService } from '../core/users/users.action';

@Injectable()
export class UserListResolver implements Resolve<User[]> {
  @select(['user', 'list'])
  userList$: Observable<User[]>;
  isUserInRedux = false;

  constructor(private service: ApiService,
              private userAction: UserActionService) {}

  resolve() {
    return this.userList$.pipe(
      first(),
      mergeMap((list) => {
        if (list.length > 0) {
          this.isUserInRedux = true;
          return of(list);
        }
        return this.service.getUser().pipe(first());
      }),
      tap((list: any) => {
        if (!this.isUserInRedux) {
          this.userAction.userList(User.fromArray(list));
        }
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di utenti');
        return of(err);
      })
    );
  }
}
